<script>
  import Button from '@components/buttons/button.svelte'
  import { cn } from '@lib/utils'

  let { variant = "default", text, size = "md", class: className, ...buttonProps } = $props()

  let actionable = $derived(buttonProps?.onclick || buttonProps?.path || buttonProps?.externalPath)

  let variants = {
    default: 'bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-200',
    success: 'bg-green-50 text-green-700 border-green-200 hover:bg-green-50 hover:border-green-200',
    warning: 'bg-yellow-50 text-yellow-700 border-yellow-200 hover:bg-yellow-50 hover:border-yellow-200',
    error: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-50 hover:border-red-200'
  }

  let variant_hover_classes = {
    default: 'hover:bg-gray-100 hover:border-gray-300',
    success: 'hover:bg-green-100 hover:border-green-300',
    warning: 'hover:bg-yellow-100 hover:border-yellow-300',
    error: 'hover:bg-red-100 hover:border-red-300'
  }

  let sizeClasses = {
    xs: 'text-xs px-2 py-1 h-6',
    sm: 'text-smaller px-2 py-1 h-7',
    md: 'text-smaller px-3 py-[0.4rem] h-8',
    lg: 'text-sm px-4 py-2 h-9',
  }

  let classes = $derived(cn(variants[variant], sizeClasses[size], actionable ? variant_hover_classes[variant] : "", className))
</script>

<Button variant="outline" size={size} class={classes} text={text} {...buttonProps} />